import React from "react";
import Label from "../atoms/Label";
import LinkItem from "./NavigationLinkItem";

export default ({ label, pages, categories, onLinkClick }) => {
  const isBlog = pages.length === 1 && categories;
  const blogPage = pages[0];
  const allPostsText = blogPage.allPostsFilter || "All posts";

  return (
    <nav className="m-navigation-group">
      <Label text={ label } classes=" m-navigation-group__label"/>

      { isBlog &&
        <LinkItem onLinkClick={ onLinkClick } slug={ blogPage.slug } title={ allPostsText }/>
      }

      { isBlog &&
        categories.map((category, index) => {
          const slug = blogPage.slug + "/?category=" + encodeURIComponent(category.name);
          return (
            <LinkItem key={ index } onLinkClick={ onLinkClick } slug={ slug } title={ category.name }/>
          )
        }) 
      }

      { !isBlog &&
        pages
          .filter(page => !page.hideForThisLocale) // Filter away pages that is not available in this language
          .map((page , index) =>
            <LinkItem key={ index } { ...page } onLinkClick={ onLinkClick } />
        ) 
      }
    </nav>
  );
}
